import { isEmpty, isNil } from 'lodash';
// Import Types
import type { DynamicVariableChannelData } from 'types';
// Import Store
import { useAppSelector } from 'store';
import { selectTemplateState } from 'store/slices/template';
import { selectPartnerLanguages } from 'store/slices/partnerLanguages';
import { selectPartnerSettingsSubscription } from 'store/slices/partnerSettings';

const useTemplatePresaveValidationProperties = (
    dynamicVariables: Nullable<DynamicVariableChannelData[]>,
    templateType: string,
) => {
    const templateData = useAppSelector(selectTemplateState);
    const partnerLanguages = useAppSelector(selectPartnerLanguages);
    const Subscription = useAppSelector(selectPartnerSettingsSubscription);

    if (isNil(Subscription?.Placeholders) || isEmpty(templateData) || isNil(dynamicVariables)) {
        return [];
    }

    return [
        {
            ForbiddenDynamicVariables: {
                templateData: templateData,
                allowedDynamicVariables: Subscription?.Placeholders,
                dynamicVariables: dynamicVariables,
                partnerLanguages: partnerLanguages,
                templateType: templateType,
            },
        },
    ];
};

export default useTemplatePresaveValidationProperties;
